import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const SURGERY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_SURGERY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.diagnoses,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.therapy,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.anamnesis,
  },
  {
    key: "social_anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.socialAnamnesis,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.allergies,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.physicalStatus,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.labResults,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.ecg,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .additionalDiagnosticFindings,
  },
  {
    key: "clinical_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.clinicalCourse,
  },
  {
    key: "recommendation",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.recommendations,
  },
  {
    key: "appointments",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.appointments,
  },
  {
    key: "parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.parameters,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .dischargeMedications,
  },
];

export function createSurgeryDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_SURGERY>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_SURGERY
  >(props, SURGERY_FIELD_CONFIG);
}
